import { SectionHeader } from "@dash/page";

import { CustomerDetails } from "@megaron/crm-contracts";

import { CustomerAlert } from "./CustomerAlert";
import { CustomerGlns } from "./CustomerGlns";

type Props = {
  customer: CustomerDetails;
  queryKey: string | string[];
};

export const AdditionalInformation: React.FC<Props> = ({ customer, queryKey }) => {
  if (customer.categories.includes("loyaltyUser")) {
    return null;
  }

  return (
    <div css={{ display: "flex", flexDirection: "column", width: "100%", gap: "1rem" }}>
      <SectionHeader isHr>Dodatkowe informacje</SectionHeader>
      <CustomerGlns customerCategories={customer.categories} customerId={customer.uuid} />
      <CustomerAlert customerUuid={customer.uuid} alert={customer.alert} queryKey={queryKey} />
    </div>
  );
};
